import { atom } from "jotai";

export const listInvestigatorAtom = atom<any[] | []>([]);
